import config from "../config";

/**
 * When we can't detect the number of cores with window.navigator.hardwareConcurrency, use this.
 */
export const MINIMUM_ASSUMED_CORES = 4;

/**
 * Leverages navigator.hardwareConcurrency API to determine
 * the number of cores available to the client.
 * If that isn't available, returns MINIMUM_ASSUMED_CORES.
 * @returns {number | null} Number of detected cores
 */
export function getUserCores() {
  const userCores =
    window.navigator?.hardwareConcurrency || MINIMUM_ASSUMED_CORES;
  if (config.debug) console.log(`Detected ${userCores} cores.`);
  return userCores;
}
/**
 * Checks whether enforceCoreLimit is enabled and if so,
 * determines if minimumRequiredCores meets users ability to support it.
 * If enforceCoreLimit is disabled, then it becomes a passthrough, returns true.
 * if enforceCoreLimis is enabled and userCores is null, throws an error.
 * @param {number} minimumRequiredCores number of cores to check against the core limit
 * @returns {boolean} true if enforceCoreLimit is enabled and minimumRequiredCores
 * is greater than or equal to total available user cores
 */
export function isCoreLimitEnforced(minimumRequiredCores) {
  if (config.pm?.mpv?.enforceCoreLimit) {
    const userCores = getUserCores();
    const hasRequiredCores = getUserCores() >= minimumRequiredCores;

    if (config.debug) {
      console.log(
        `Requested ${minimumRequiredCores} cores. User supports ${userCores} cores.`,
      );
    }

    return hasRequiredCores;
  } else {
    return true;
  }
}

/**
 * Utility to detect whether the browser supports offscreenCanvas
 * @export
 * @returns {boolean} true if the browser supports offscreenCanvas
 */
export const supportsOffscreenCanvas = () => {
  const canvasObj = document.createElement("canvas");
  if (
    typeof canvasObj.transferControlToOffscreen === "function" &&
    typeof OffscreenCanvas !== "undefined"
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * Wrapper for supportsOffscreenCanvas
 * @export
 * @returns {boolean} true if the browser supports offscreenCanvas
 */
export const hasOffscreenCanvas = supportsOffscreenCanvas();
